// Selos discretos dos métodos de pagamento, ao estilo das lojas online: pequenos cartões de contorno fino, em tons suaves.
// São marcas simplificadas a um só tom (não os logótipos oficiais); o texto alternativo diz o nome de cada método.
const W = 44;
const H = 28;
const Card = ({ label, children }) => (
  <svg role="img" aria-label={label} viewBox={`0 0 ${W} ${H}`} width={W} height={H} className="shrink-0 text-ink/70">
    <title>{label}</title>
    <rect x=".5" y=".5" width={W - 1} height={H - 1} rx="5" fill="rgba(255,255,255,.55)" stroke="currentColor" strokeOpacity=".28" />
    {children}
  </svg>
);
const T = ({ x = 22, y = 18, size = 10, weight = 700, style, spacing, children }) => (
  <text x={x} y={y} textAnchor="middle" fontSize={size} fontWeight={weight} fontStyle={style} letterSpacing={spacing} fill="currentColor" fontFamily="'Plus Jakarta Sans', Arial, sans-serif">{children}</text>
);

const BADGES = {
  "Cartão": () => (
    <Card label="Cartão (Visa e Mastercard)">
      <circle cx="17" cy="14" r="6.5" fill="currentColor" fillOpacity=".55" />
      <circle cx="27" cy="14" r="6.5" fill="currentColor" fillOpacity=".35" />
    </Card>
  ),
  "MB Way": () => <Card label="MB WAY"><T size={9} spacing=".3">MB</T><T y={24} size={6.5} weight={600}>WAY</T></Card>,
  Multibanco: () => (
    <Card label="Multibanco">
      <rect x="14" y="7" width="16" height="14" rx="2" fill="currentColor" fillOpacity=".12" stroke="currentColor" strokeOpacity=".5" />
      <T y={17.5} size={8.5}>MB</T>
    </Card>
  ),
  "Apple Pay": () => <Card label="Apple Pay"><T size={9.5} weight={600}>Pay</T><path d="M12.4 12.6c.6-.7 1-1.5.9-2.4-.8 0-1.7.5-2.3 1.2-.5.6-.9 1.5-.8 2.3.9.1 1.7-.4 2.2-1.1z" fill="currentColor" transform="translate(2 -1.5) scale(.85)" /></Card>,
  "Revolut Pay": () => <Card label="Revolut Pay"><T y={19} size={14} weight={800}>R</T></Card>,
  Klarna: () => <Card label="Klarna"><T size={8.5} spacing="-.1">Klarna.</T></Card>,
};

export const PaymentBadges = ({ methods }) => (
  <ul className="flex flex-wrap items-center gap-1.5" aria-label="Métodos de pagamento">
    {methods.map((m) => {
      const Badge = BADGES[m];
      return <li key={m}>{Badge ? <Badge /> : <span className="rounded-md border border-ink/20 px-2 py-1 text-ink/70">{m}</span>}</li>;
    })}
  </ul>
);
